import {
  fromJS,
  List,
  Map,
}                                from 'immutable';
import invariant                 from 'invariant';
import {
  combineActions,
  handleActions
}                                from 'redux-actions';
import { STATE_PROP_FETCHED_AT } from '../../../apiResources.const';
import {
  buildCreateActions,
  buildListActions,
  buildShowActions,
  buildUpdateActions
}                                from '../../../../actions/utils/apiResources/buildSyncActions';
import {
  METHOD_GET,
  METHOD_PUT
}                                from '../../../../actions/utils/apiResources/apiResourceActions.const';


const buildByIdReducer = (resource) => {

  const listActions      = buildListActions(resource);
  const createActions    = buildCreateActions(resource);
  const showActions      = buildShowActions(resource);
  const updateGetActions = buildUpdateActions(resource, METHOD_GET);
  const updatePutActions = buildUpdateActions(resource, METHOD_PUT);

  const listGetSuccess    = listActions.success;
  const createPostSuccess = createActions.success;
  const showGetSuccess    = showActions.success;
  const updateGetSuccess  = updateGetActions.success;
  const updatePutSuccess  = updatePutActions.success;

  const singularActions = combineActions(createPostSuccess, showGetSuccess, updateGetSuccess, updatePutSuccess);

  //---
  // Here we use named function variables, as that during tests we can identify which calls to handleActions to expect

  return handleActions(
    {

      [listGetSuccess](state, {payload: {receivedData}}) {

        invariant(receivedData, 'Missing receivedData');

        const data = fromJS(receivedData);

        if (!(data.get('hydra:member') instanceof List)) {

          return state;

        }

        const now = (new Date()).toISOString();

        return state.merge(
          data.get('hydra:member').reduce((accumulator, item) => {

            return accumulator.set(item.get('@id'), item.set(STATE_PROP_FETCHED_AT, now));

          }, Map())
        );

      },

      [singularActions](state, {type, payload: {receivedData}, meta: {url, alias}}) {

        invariant(receivedData, 'Missing receivedData');

        const data = fromJS(receivedData).set(STATE_PROP_FETCHED_AT, (new Date()).toISOString());

        // If we've created a new resource,

        if (String(createPostSuccess) === type) {

          url = data.get('@id');

        }

        if (data.get('@id') !== url) {

          console.warn(
            `Resource @id (${data.get('@id')}) property does not match expected url (${url}) or alias (${alias})`
          );

        }

        // We need  to use the URL as the @id will be the main resource endpoint when fetching special endpoints.
        state = state.set(url, data);

        if (alias) {

          state.set(alias, data);

        }

        return state;

      },

    },

    Map()
  );

};

export default buildByIdReducer;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/items/buildByIdReducer.js